import { EntityId } from "@reduxjs/toolkit";

export enum IncidentType {
    Unwell = "Unwell",
    Violence = "Violence",
}

export enum IncidentFootageType {
    Image = "Image",
    Video = "Video",
}

export interface IncidentFootage {
    id: EntityId;
    deviceName: string;
    fileName: string;
    timestamp: string;
    footageType: IncidentFootageType;
}

export interface Incident {
    id: EntityId;
    siteId: EntityId;
    incidentType: IncidentType;
    timestamp: string;
    footage: IncidentFootage[];
}
